import Reveal from '../components/Reveal';
import { useLanguage } from '../context/LanguageContext';

function IdeasPage() {
  const { t, isArabic } = useLanguage();
  // In Arabic the certificate sits on the left and the supermarket on the right, the way they
  // appear in the picture above them; the cards keep their own styling either way.
  const ideaCards = t.ideasPage.cards.map((card, index) => ({ card, index }));
  const orderedIdeaCards = isArabic ? [...ideaCards].reverse() : ideaCards;
  const extrasImages = [
    `${process.env.PUBLIC_URL}/images/Governmentprojects.jfif`,
    `${process.env.PUBLIC_URL}/images/franchise.jfif`,
  ];

  return (
    <main className="inner-page">
      <section className="container page-hero">
        <Reveal>
          <span className="eyebrow ideas-main-eyebrow">{t.ideasPage.eyebrow}</span>
          <h1>{t.ideasPage.title}</h1>
          <p>{t.ideasPage.subtitle}</p>
        </Reveal>
      </section>

      <section className="container ideas-page-cards">
        {/* One picture for both ideas: the certificate on one half, the supermarket on the other. */}
        <Reveal>
          <div className="ideas-shared-image">
            <img
              src={`${process.env.PUBLIC_URL}/images/supermarketandcertificate.jfif`}
              alt={t.ideasPage.title}
            />
          </div>
        </Reveal>
        <div className="ideas-grid">
          {orderedIdeaCards.map(({ card, index }) => (
            <Reveal key={card.title} direction={index % 2 === 0 ? 'left' : 'right'}>
              <article className={`idea-card ${index === 0 ? 'idea-primary' : 'idea-secondary'}`}>
                <div className="idea-body">
                  <span className="material-symbols-outlined idea-icon">{card.icon}</span>
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section certificate-deep">
        <div className="container">
          <Reveal>
            <div className="services-head">
              <span className="eyebrow center">{t.ideasPage.certificateDeep.eyebrow}</span>
              <h2>{t.ideasPage.certificateDeep.title}</h2>
              <p>{t.ideasPage.certificateDeep.subtitle}</p>
            </div>
          </Reveal>
          <div className="certificate-points">
            {t.ideasPage.certificateDeep.points.map((p, i) => (
              <Reveal key={p.title} delay={i * 120}>
                <article className="certificate-point">
                  <span className="certificate-step">0{i + 1}</span>
                  <span className="material-symbols-outlined certificate-icon">{p.icon}</span>
                  <h3>{p.title}</h3>
                  <p>{p.text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section extras-zigzag-section">
        <div className="container">
          <Reveal>
            <span className="eyebrow center ideas-extras-eyebrow">{t.ideasPage.extrasEyebrow}</span>
            <h2 className="center-title">{t.ideasPage.extrasTitle}</h2>
          </Reveal>
          <div className="extras-zigzag-list">
            {t.ideasPage.extras.map((item, i) => (
              <article
                key={item.title}
                className={`extras-zigzag-row ${i % 2 === 1 ? 'extras-zigzag-row-reverse' : ''}`}
              >
                <Reveal direction={i % 2 === 1 ? 'right' : 'left'}>
                  <article className="extras-zigzag-content">
                    <span className="material-symbols-outlined goal-icon">{item.icon}</span>
                    <h3>{item.title}</h3>
                    {item.subtitle ? <p className="extras-zigzag-subtitle">{item.subtitle}</p> : null}
                    <p>{item.text}</p>
                  </article>
                </Reveal>
                <Reveal direction={i % 2 === 1 ? 'left' : 'right'}>
                  <div className="extras-zigzag-image">
                    <img src={extrasImages[i % extrasImages.length]} alt={item.title} />
                  </div>
                </Reveal>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default IdeasPage;
